import { Component, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SHARED_MODULES } from 'src/app/modules/shared-imports';
import { NetworkStatusService } from 'src/app/services/network-status.service';

// Subtle, non-blocking indicator for a slow (but working) connection — deliberately NOT the same
// treatment as the full-width "You are offline" bar in app.component.html, which is a much more
// severe, action-blocking state. This is informational only: things still work, they might just
// take a little longer. Auto-appears/disappears with NetworkStatusService.slowConnection(); a
// manual dismiss only suppresses the CURRENT slow spell — it reappears on the next one, since
// permanently silencing it would defeat the point when the connection is genuinely bad later.
@Component({
  selector: 'app-slow-connection-indicator',
  standalone: true,
  imports: [CommonModule, SHARED_MODULES],
  templateUrl: './slow-connection-indicator.component.html',
  styleUrls: ['./slow-connection-indicator.component.css'],
})
export class SlowConnectionIndicatorComponent {
  private readonly networkStatusService = inject(NetworkStatusService);
  private dismissed = false;

  constructor() {
    effect(() => {
      if (!this.networkStatusService.slowConnection()) {
        this.dismissed = false; // reset so the NEXT slow spell shows again
      }
    });
  }

  get visible(): boolean {
    // Suppressed while fully offline — the offline bar already covers that, more severe, case;
    // showing both at once would be redundant and visually noisy.
    return this.networkStatusService.slowConnection() && this.networkStatusService.isOnline && !this.dismissed;
  }

  dismiss(): void {
    this.dismissed = true;
  }
}
